import { ErrorMessage } from '@as-react/common-types';
import { useAemConfig } from '@as-react/common-components';
import { generalQueries } from '@as-react/common-queries';
import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { checkVAT, countries } from 'jsvat-next/lib/es6';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { mapWithAssert } from '../../../util/ArrayUtil';
import { generateFieldName } from '../address-fields/addressFields.utils';
import { InvoiceFieldName } from './invoiceFields.utils';
export var FinanceFieldName;
(function (FinanceFieldName) {
    FinanceFieldName["IS_VAT"] = "isVat";
    FinanceFieldName["IS_VIES_VERIFIED"] = "isViesVerified";
})(FinanceFieldName || (FinanceFieldName = {}));
export const InvoiceFieldsWatcher = ({ country, prefix }) => {
    const { t } = useTranslation([I18N_NAMESPACES.buy, I18N_NAMESPACES.account]);
    const { control, setError, setValue } = useFormContext();
    const { defaultRequestParams, servicesEndpoint } = useAemConfig();
    const [vatNumberField, companyNameField] = mapWithAssert([InvoiceFieldName.VAT_NUMBER, InvoiceFieldName.COMPANY_NAME], name => generateFieldName(name, prefix || 'invoice.'));
    const [isVatField, isViesVerifiedField] = mapWithAssert([FinanceFieldName.IS_VAT, FinanceFieldName.IS_VIES_VERIFIED], name => generateFieldName(name, prefix || 'finance.'));
    const vatNumber = useWatch({ control, name: vatNumberField });
    const { getCompanyDetailsByVAT } = generalQueries({ servicesEndpoint, defaultRequestParams });
    const currentCountry = country && countries.find(item => item.codes.includes(country.toUpperCase()));
    const { data: companyDetails, error: companyDetailsError } = useQuery(getCompanyDetailsByVAT({ country: vatNumber.slice(0, 2), vatNumber: vatNumber.slice(2) }, {
        enabled: Boolean(currentCountry) && checkVAT(vatNumber, [currentCountry]).isValid,
        retry: false,
    }));
    useEffect(() => {
        if (companyDetailsError) {
            setError(vatNumberField, { message: t(`${I18N_NAMESPACES.buy}:buy.error.no.results`) });
        }
    }, [companyDetailsError]);
    useEffect(() => {
        if (!companyDetails) {
            return;
        }
        if (!companyDetails.isVat) {
            setError(vatNumberField, { message: t(ErrorMessage.INVALID_VAT_NUMBER) });
        }
        setValue(companyNameField, companyDetails.viesResponse.name, { shouldValidate: true });
        setValue(isVatField, companyDetails.isVat);
        setValue(isViesVerifiedField, companyDetails.isViesVerified);
    }, [companyDetails]);
    return null;
};
